import { render, staticRenderFns } from "./reporterNews.vue?vue&type=template&id=0bd93b20&scoped=true"
import script from "./reporterNews.vue?vue&type=script&lang=ts"
export * from "./reporterNews.vue?vue&type=script&lang=ts"
import style0 from "./reporterNews.vue?vue&type=style&index=0&id=0bd93b20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd93b20",
  null
  
)

export default component.exports